import { isValidEmail } from "../helpers";
import { validateContact, validateName } from "./GlobalValidations";

export function validateSignUp(values) {
    let errors = {}
    if (validateName(values.firstName, true))
        errors.firstName = validateName(values.firstName, true)
    else if (validateName(values.lastName, true))
        errors.lastName = validateName(values.lastName, true)
    else if (!values.email)
        errors.email = "Email is required"
    else if (validateContact(values.contact, true))
        errors.contact = validateContact(values.contact, true)
    else if (!isValidEmail(values.email))
        errors.email = "Email is invalid"
    else if (!values.password)
        errors.password = "Password is required"
    else if (values.password.length < 8)
        errors.password = "Password can't be less than 8 characters"
    else if (!values.confirmPassword)
        errors.confirmPassword = "Password Confirmation is required"
    else if (values.password !== values.confirmPassword)
        errors.confirmPassword = "Password don't match"
    else if (!values.selectedCountry.id)
        errors.selectedCountry = "Country is required"

    return errors;
}